<template>
  <div class="contactinfo">
    <toptitle :title1="titlework" />
    <van-cell-group>
      <van-field
        v-model="mobilePhone"
        label="手机号"
        placeholder="请输入联系手机"
        clearable
      />
    </van-cell-group>
    <van-cell-group>
      <van-field
        v-model="SMSCODE"
        center
        required
        clearable
        label="验证码"
        placeholder="请输入验证码"
        :border="false"
        use-button-slot
      >
        <van-button slot="button" size="small" type="info" @click="gainCode">{{
          countDown
        }}</van-button>
      </van-field>
    </van-cell-group>
    <van-cell-group>
      <van-field
        v-model="cornet"
        label="短号"
        placeholder="请输入短号"
        clearable
      />
    </van-cell-group>
    <!-- <div class="radio-mar">
      <div class="radio-title">婚姻状况</div>
      <van-radio-group :value="marStatus"
                       bind:change="onChange"
                       direction="horizontal">

        <van-radio name="M">已婚</van-radio>
        <van-radio name="S">未婚</van-radio>
        <van-radio name="O">其他</van-radio>
      </van-radio-group>
    </div> -->
    <van-cell-group>
      <van-field
        readonly
        clickable
        required
        label="婚姻状况"
        placeholder="请选择婚姻状况"
        :value="marStatus"
        @click="showPopup4"
      />
      <van-popup v-model="show4" round position="bottom">
        <van-picker
          show-toolbar
          title="请选择婚姻状况"
          :columns="columns4"
          @cancel="onCancel"
          @confirm="onConfirm4"
        />
      </van-popup>
    </van-cell-group>
    <van-cell-group>
      <van-field
        readonly
        clickable
        required
        label="入党日期"
        placeholder="请选择入党日期"
        :value="joinDate"
        @click="showPopup5"
      />
      <van-popup v-model="show5" round position="bottom">
        <van-datetime-picker
          type="date"
          @confirm="onConfirm5"
          @cancel="onCancel"
          title="请选择入党日期"
          :min-date="minDate"
          :max-date="maxDate"
        />
      </van-popup>
    </van-cell-group>
    <van-cell-group>
      <van-field
        v-model="emailPers"
        label="个人邮箱"
        placeholder="请输入个人邮箱"
        clearable
      />
    </van-cell-group>
    <van-cell-group>
      <van-field
        v-model="address"
        label="现居住地址"
        required
        placeholder="请输入现居住地址"
        clearable
      />
    </van-cell-group>
    <van-cell-group>
      <van-field
        v-model="familyAddress"
        label="家庭地址"
        required
        placeholder="请输入家庭地址"
        clearable
      />
    </van-cell-group>

    <p class="blank">紧急联系人信息</p>

    <van-cell-group>
      <van-field
        v-model="rName"
        label="姓名"
        placeholder="请输入紧急联系人"
        clearable
        required
      />

      <van-field
        v-model="relatedPhone"
        label="联系人电话"
        placeholder="请输入联系人电话"
        clearable
        required
      />
    </van-cell-group>
    <van-cell-group>
      <van-field
        readonly
        clickable
        required
        label="与本人关系"
        placeholder="请选择与本人关系"
        :value="relateShip"
        @click="showPopup"
      />
      <van-popup v-model="show" round position="bottom">
        <van-picker
          show-toolbar
          title="请选择与本人关系"
          :columns="columns1"
          @cancel="onCancel"
          @confirm="onConfirm"
        />
      </van-popup>
    </van-cell-group>
    <div class="button-bt">
      <div @click="submit">提交</div>
      <div @click="cancel">取消</div>
    </div>
  </div>
</template>

<script>
  import { Toast } from 'vant';
  import toptitle from '../../components/toptitle';
  import {
    changeDataApi,
    changeResumeDataApi,
    smsPhoneDataApi
  } from '../../request/api';

  import dateformat from '@/utils/dateformat';
  import isempty from '@/utils/isempty';
  export default {
    data() {
      name: 'contactinfo';
      return {
        isClick: true,
        show: false,
        show4: false,
        show5: false,
        countDown: '获取验证码',
        titlework: '编辑个人基本信息',
        paramData: null,
        mobilePhone: '',
        cornet: '',
        SMSCODE: '',
        marStatus: '',
        joinDate: '',
        emailPers: '',
        address: '',
        familyAddress: '',
        rName: '',
        relateShip: '',
        relatedPhone: '',
        columns1: [],
        columns4: ['已婚', '未婚', '其他'],
        relationArr: [],
        minDate: new Date(1949, 0, 1),
        maxDate: new Date()
      };
    },
    methods: {
      cancel() {
        this.$router.push('/resume');
      },
      showPopup() {
        this.show = true;
      },
      showPopup4() {
        this.show4 = true;
      },
      showPopup5() {
        this.show5 = true;
      },
      onConfirm(value) {
        this.relateShip = value;
        this.show = false;
      },
      onConfirm4(value) {
        this.marStatus = value;
        this.show4 = false;
      },
      onConfirm5(value) {
        this.joinDate = dateformat('yyyy-MM-dd', value);
        this.show5 = false;
      },
      onCancel() {
        this.show = false;
        this.show4 = false;
        this.show5 = false;
      },
      async gainCode() {
        if (this.isClick) {
          if (this.mobilePhone.length == 11) {
            let params = {
              MOBILE_PHONE: this.mobilePhone,
              EMPLID: sessionStorage.getItem('EMPLID')
            };
            // 获取验证码接口
            smsPhoneDataApi(params).then(res => {
              if (res.CODE === 200) {
                this.$toast('短信发送成功');
                this.isClick = false;
                let stime = 60;
                this.countDown = stime + 's';
                let interval = setInterval(() => {
                  stime--;
                  this.countDown = stime + 's';
                  if (stime <= 0) {
                    this.countDown = '重新获取';
                    this.isClick = true;
                    clearInterval(interval);
                  }
                }, 1000);
              } else {
                this.$toast(res.MESSAGE);
                this.countDown = '重新获取';
                this.isClick = true;
                clearInterval(interval);
              }
            });
          } else {
            this.$toast('请输入正确手机号');
          }
        }
      },

      submit() {
        if (isempty(this.mobilePhone)) {
          this.$toast('请填写手机号');
          return false;
        }

        if (isempty(this.rName)) {
          this.$toast('请填写紧急联系人姓名');
          return false;
        }

        if (isempty(this.relatedPhone)) {
          this.$toast('请填写紧急联系人电话');
          return false;
        }
        const regMail = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;
        if (this.emailPers) {
          if (!regMail.test(this.emailPers)) {
            this.$toast('请填写正确邮箱');
            return false;
          }
        }
        // const regMobile = /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/
        // if (!regMobile.test(this.mobilePhone)) {
        //   Toast.fail('联系手机格式不正确')
        //   return
        // }
        // if (!regMobile.test(this.relatedPhone)) {
        //   Toast.fail('紧急联系人手机格式不正确')
        //   return
        // }
        if (this.mobilePhone.length != 11) {
          Toast.fail('请输入11位手机号');
          return false;
        }
        if (this.relatedPhone.length != 11) {
          Toast.fail('请输入11位紧急联系人手机号');
          return false;
        }
        let marry = '';
        if (this.marStatus == '已婚') {
          marry = 'M';
        } else if (this.marStatus == '未婚') {
          marry = 'S';
        } else if (this.marStatus == '其他') {
          marry = 'O';
        }
        if (!marry) {
          Toast.fail('请填写婚姻状况');
          return;
        }

        let relationOne = '';
        this.relationArr.forEach(element => {
          if (this.relateShip == element.XLADSHORTNAME) {
            relationOne = element.FIELDVALUE;
          }
        });

        let params = {
          EMPLID: sessionStorage.getItem('EMPLID'),
          MOBILE_PHONE: this.mobilePhone,
          C_MOBILE_SHORT_NUMBER: this.cornet,
          MAR_STATUS: marry,
          C_JOIN_PARTY_DT: this.joinDate,
          SMSCODE: this.SMSCODE,
          C_EMAIL_PERS: this.emailPers,
          C_RELATED_NAME: this.rName,
          C_RELATIONGSHIP: relationOne,
          C_RELATED_PHONE: this.relatedPhone,
          C_ADDRESS_CUR: this.address,
          C_ADDRESS_CE: this.familyAddress
        };
        JSON.stringify(params);
        changeResumeDataApi(params).then(res => {
          if (res.CODE == 200) {
            Toast.success('提交成功');
            this.$router.back('/resume');
          } else {
            Toast.fail(res.MESSAGE);
          }
        });
      }
    },
    components: {
      toptitle
    },
    created() {
      this.paramData = this.$route.query.paramData;
      if (!this.paramData) {
        this.paramData = {
          EMPLID: '',
          MOBILE_PHONE: '',
          MAR_STATUS: '',
          C_EMAIL_PERS: '',
          C_RELATED_NAME: '',
          C_RELATIONGSHIP: '',
          C_RELATED_PHONE: '',
          C_ADDRESS_CUR: '',
          C_ADDRESS_CE: ''
        };
      }

      // this.mobile_phone = this.paramData.EMPLID
      this.mobilePhone = this.paramData.MOBILE_PHONE;
      this.cornet = this.paramData.C_MOBILE_SHORT_NUMBER;
      this.marStatus = this.paramData.MAR_STATUS;
      this.joinDate = this.paramData.C_JOIN_PARTY_DT;
      this.emailPers = this.paramData.C_EMAIL_PERS;
      this.address = this.paramData.C_ADDRESS_CUR;
      this.familyAddress = this.paramData.C_ADDRESS_CE;
      this.rName = this.paramData.C_RELATED_NAME;
      this.relateShip = this.paramData.C_RELATIONGSHIP;
      this.relatedPhone = this.paramData.C_RELATED_PHONE;

      let params3 = { FIELDNAME: 'C_RELATIONGSHIP' }; //紧急联系人关系
      changeDataApi(params3).then(res => {
        this.relationArr = res.DATA;
        this.columns1 = this.relationArr.map(item => {
          return item.XLADSHORTNAME;
        });
      });
    }
  };
</script>

<style lang="less" scoped>
  .provesec {
    display: flex;
    line-height: 44px;
    background: white;
    padding-left: 16px;
    .arrow {
      flex: 1;
      text-align: right;
      line-height: 44px;
      color: #c4c4c6;
    }
  }
  /deep/ .van-radio-group {
    overflow: hidden;
    color: #323233;
    font-size: 14px;
    line-height: 24px;
    background-color: #fff;
  }
  /deep/ .van-radio__label {
    color: #969799;
  }
  /deep/ .van-cell__value {
    text-align: right;
  }

  /deep/ .van-cell__title {
    font-size: 16px;
    color: black;
  }
  /deep/ input.van-field__control {
    text-align: right;
  }
  .radio-title {
    font-size: 16px;
    color: black;
  }
  .radio-mar {
    position: relative;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    box-sizing: border-box;
    padding: 10px 16px;
    padding-right: 0px;
    width: 100%;
    justify-content: space-between;
    overflow: hidden;
    color: #323233;
    font-size: 14px;
    line-height: 24px;
    background-color: #fff;
  }
  .blank {
    height: 44px;
    line-height: 44px;
    font-size: 14px;
    padding: 0 16px;
    color: #888888;
  }
  .button-bt {
    position: fixed;
    bottom: 0;
    display: flex;
    line-height: 44px;
    text-align: center;
    color: white;
    width: 100%;
    div {
      background: #1989fa;
      width: 50%;
      font-size: 17px;
    }
  }
</style>
